export default __webpack_public_path__ + "static/media/donefile.55839dd6.svg";